const hostnameRegex: RegExp =
  /^(explore|qa\.explore|uat\.explore|dev\.explore|localhost)\.avela\.org$|^localhost$/;

export const pathRoutingEnabled = (): boolean =>
  hostnameRegex.test(window.location.hostname);

export function imageUrl(clientID: string, placementId: string): string {
  return `${process.env.REACT_APP_BUCKET_URL}/output/${clientID}/images/${placementId}.jpg`;
}

export function thumbnailUrl(clientID: string, placementId: string): string {
  return `${process.env.REACT_APP_BUCKET_URL}/output/${clientID}/images/${placementId}-tn.jpg`;
}
